// constants
const SET_ALERT = "SET_ALERT";

// actions
export const setAlert = (payload) => ({
  type: SET_ALERT,
  payload,
});

// reducer
const initialState = {
  severity: "success",
  message: "",
  show: false
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ALERT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
